import React from "react";
import { Link } from "@quintype/components";
import PT from "prop-types";

import "./sticky-navbar.m.css";

const StickyNavbar = ({ onMenuToggle, menuItems = [] }) => {
  const renderIcon = (iconCode) => (
    <div styleName="icon-wrapper">
      {iconCode && <img src={iconCode} alt="icon" loading="eager" />}
    </div>
  );

  const renderNavItem = (item, index) => {
    const {
      title = "",
      data = {},
      completeUrl,
      isExternalLink = false
    } = item;

    const iconCode = data["icon-code"] || data.iconCode || "";
    const link = data.link || completeUrl;

    const isMenuToggle =
      title === "ಮೆನು" || title.toLowerCase() === "menu";

    // Menu item opens drawer
    if (isMenuToggle) {
      return (
        <div
          key={index}
          styleName="button center-column"
          onClick={onMenuToggle}
          role="button"
          tabIndex={0}
        >
          {renderIcon(iconCode)}
          <span styleName="text">{title}</span>
        </div>
      );
    }

    return (
      <button key={index} styleName="button center-column">
        <Link
          href={link}
          externalLink={isExternalLink}
          target="_blank"
          rel="noopener noreferrer"
          styleName="link center-column"
        >
          {renderIcon(iconCode)}
          <span styleName="text">{title}</span>
        </Link>
      </button>
    );
  };

  return (
    <div styleName="navbar" id="sticky-bottom-navbar">
      {menuItems.map(renderNavItem)}
    </div>
  );
};

StickyNavbar.propTypes = {
  onMenuToggle: PT.func,
  menuItems: PT.array
};

export default StickyNavbar;
